export function getExtensionFromMimeType(mimeType: string): string {
    const mimeTypes: Record<string, string> = {
        // Documentos comunes
        'application/pdf': 'pdf',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
        'application/vnd.ms-excel': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
        'application/vnd.ms-powerpoint': 'ppt',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',

        // Imágenes
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'image/bmp': 'bmp',
        'image/webp': 'webp',

        // Audio
        'audio/mpeg': 'mp3',
        'audio/wav': 'wav',
        'audio/ogg': 'ogg',
        'audio/x-m4a': 'm4a',

        // Video
        'video/mp4': 'mp4',
        'video/webm': 'webm',
        'video/ogg': 'ogv',

        // Archivos comprimidos
        'application/zip': 'zip',
        'application/x-rar-compressed': 'rar',
        'application/x-7z-compressed': '7z',
        'application/x-tar': 'tar',

        // Archivos de texto y código
        'text/plain': 'txt',
        'text/html': 'html',
        'application/json': 'json',
        'application/javascript': 'js',
        'application/xml': 'xml',
        'text/css': 'css',
        'text/csv': 'csv',

        // Otros
        'application/octet-stream': 'bin',
    };

    return mimeTypes[mimeType] || 'unknown';
}

